import moment from "moment";

/**
 * 日時変換util
 */
export class DateUtil {
    /**
     * 指定の日付を文字列に変換する
     * @param val 変換対象の値
     * @return 文字列に変換した値
     */
    static parseDate = (val: Date | undefined, format = `YYYY/MM/DD`): string => {
        const date = moment(val);
        const dateVal = date.format(format);
        return dateVal;
    };

    /**
     * 指定の時間を文字列に変換する
     * @param val 変換対象の値
     * @return 文字列に変換した値
     */
    static parseTime = (val: Date | undefined): string => {
        const time = moment(val);
        const timeVal = time.format(`HH:mm:ss`);
        return timeVal;
    };

    /**
     * 指定の時間を文字列に変換する
     * @param start 変換対象の値（予約開始時間）
     * @param end 変換対象の値（予約終了時間）
     * @returns 文字列に変換した値
     */
    static parseViewTime = (start: Date, end: Date): string => {
        const startVal = moment(start).format(`HH:mm`);
        const endVal = moment(end).format(`HH:mm`);
        return `${startVal}～${endVal}`;
    };

    /**
     * 指定の日時を文字列に変換する
     * @param start 変換対象の値（予約開始時間）
     * @param end 変換対象の値（予約終了時間）
     * @returns 文字列に変換した値
     */
    static parseViewDate = (start: Date, end: Date): string => {
        const startVal = moment(start).format(`YYYY年MM月DD日 (ddd) HH:mm`);
        const endVal = moment(end).format(`HH:mm`);
        return `${startVal}～${endVal}`;
    };

    /**
     * 指定の日時を文字列に変換する
     * @param start 変換対象の値（予約開始日時）
     * @returns 文字列に変換した値
     */
    static parseViewDateForDialog = (start: Date): string => {
        const date = moment(start).format(`YYYY年MM月DD日 (ddd) `);
        return date;
    };
}
